export default __webpack_public_path__ + "locales/sl/DownloadDialog.json?hash=a2f58916fc6cddc2230897784cc23487";